import { Card } from '@/components/ui/card'
import { Typography } from '@/components/ui/typography'

// Long enough to fill the highest limit, so every slider position shows a full sample.
const CARD_MESSAGE_PREVIEW_SAMPLE =
  'Happy birthday, Mom! Wishing you a day as bright and beautiful as these flowers. ' +
  'Thank you for every early morning, every late night, and all the love you give us. ' +
  'We are so lucky to call you ours, and we cannot wait to celebrate with you this weekend. ' +
  'All our love, today and always.'

/** Sample message text cut to the florist's limit, so they can see how much writing it allows. */
export function CardMessageLengthPreview({ maxLength }: { maxLength: number }) {
  return (
    <div className="space-y-2">
      <Typography variant="label" tone="muted" className="block">
        Example
      </Typography>
      <Card surface="subtle" className="p-4">
        <Typography variant="bodySmall" className="break-words">
          {CARD_MESSAGE_PREVIEW_SAMPLE.slice(0, maxLength)}
        </Typography>
      </Card>
    </div>
  )
}
